<app-modal-wrapper [staticHeight]="staticHeight" [modal]="modal">
  <ng-container>
    <div class="modal-header">
      <p class="header-title">
        Запрет изменения параметров<br />
        для счета {{ formattedAccountNumber }}
      </p>
    </div>

    <div class="disable-parameter-changes-content">
      <!-- Первичное описание (до выполнения операции) -->
      <div class="warning-message" *ngIf="!isCompleted">
        <ion-icon name="information-circle-outline" class="warning-icon"></ion-icon>
        <p class="warning-text">
          Внимание! После запрета провести изменения параметров счета можно будет только в офисе банка
        </p>
      </div>

      <!-- Сообщение об успешном запрете -->
      <div class="result-message success" *ngIf="isCompleted && isSuccess">
        <ion-icon name="information-circle-outline" class="result-icon"></ion-icon>
        <p class="result-text">
          Установлен запрет на изменение параметров счета. Для изменения параметров обратитесь в офис банка.
        </p>
      </div>

      <!-- Сообщение об ошибке -->
      <div class="result-message error" *ngIf="isCompleted && !isSuccess">
        <ion-icon name="information-circle-outline" class="result-icon error"></ion-icon>
        <p class="result-text error">{{ errorText }}</p>
      </div>
    </div>
  </ng-container>

  <ion-footer class="ion-no-border" footer *ngIf="!isCompleted">
    <ion-button class="button block primary shadow" mode="ios" expand="block" (click)="disableParameterChanges()">
      Запретить изменение
    </ion-button>
  </ion-footer>

  <ion-footer class="ion-no-border" footer *ngIf="isCompleted">
    <ion-button class="button block primary shadow" mode="ios" expand="block" (click)="goToMain()">
      На главный экран
    </ion-button>
  </ion-footer>
</app-modal-wrapper>
